module.exports = __webpack_public_path__ + "static/img/serviceContent3.9750c79e.png";